import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  /* function handleDelete({ row }) {
       Bus.$emit("deleteCreditRule", row);
     }*/

  function handleEnableAndDisable(data) {
    Bus.$emit("handleEnableAndDisable", data);
  }

  const Deal = ({ props: { vo } }) => {
    const creditRule = vo.row;
    const dealConf = [];
    if (creditRule.resourceType == 0) {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => {
          // router.push({
          //   path: "/creditRule/edit/editVideoType",
          //   query: { id: creditRule.uuid }
          // });
          Bus.$emit(
            "ReceiveMessage",
            Object.assign({}, { id: creditRule.uuid, type: "video" })
          );
        },
        "creditRule:update"
      ]);
    } else if (creditRule.resourceType == 1) {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => {
          Bus.$emit(
            "ReceiveMessage",
            Object.assign({}, { id: creditRule.uuid, type: "book" })
          );
        },
        "creditRule:update"
      ]);
    } else if (vo.row.resourceType == 2) {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => {
          Bus.$emit(
            "ReceiveMessage",
            Object.assign({}, { id: creditRule.uuid, type: "article" })
          );
        },
        "creditRule:update"
      ]);
    }

    if (creditRule.ruleStatus == 0) {
      dealConf.push([
        "icon-enable",
        "启用",
        () => handleEnableAndDisable(creditRule),
        "creditRule:enableAndDisable"
      ]);
    } else {
      dealConf.push([
        "icon-unable",
        "停用",
        () => handleEnableAndDisable(creditRule),
        "creditRule:enableAndDisable"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}>
              {" "}
            </i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "类型",
      prop: "resourceTypeName",
      minWidth: "100"
    },
    {
      label: "组织名称",
      prop: "deptName",
      minWidth: "150"
    },
    {
      label: "状态",
      prop: "ruleStatusName",
      minWidth: "150"
    },
    {
      label: "操作",
      minWidth: "100",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
